import { useEffect } from 'react';

import {
  FULL_PAGE_STATUS_CODE,
  MODAL_STATUS_CODE,
  ONLY_COMPONENT_STATUS_CODE,
  useModal,
  useServiceAppState,
  WITH_GNB_STATUS_CODE,
} from '@kc-console/context';

import { ErrorModal } from '../../modals';
import FullPageErrorMapper from '../ErrorLayout/FullPageErrorMapper';
import InServiceErrorMapper from '../ErrorLayout/InServiceErrorMapper';
import WithGnbErrorMapper from '../ErrorLayout/WithGnbErrorMapper';

import type { ErrorModalProps } from '../../modals/ErrorModal';
import type { CommonLayoutProps } from '../AppLayout/types';

const ErrorWrapper = ({ children, pageProps }: CommonLayoutProps) => {
  const { openModal } = useModal();
  const {
    state: { status },
  } = useServiceAppState();

  useEffect(() => {
    if (MODAL_STATUS_CODE.includes(status)) {
      openModal<ErrorModalProps>({ Component: ErrorModal, props: { status } });
    }
  }, [openModal, status]);

  /**
   * Layout 컴포넌트 렌더링 전에 전역 에러를 보여줘야하는 경우 Mapper 렌더링
   */
  if ([...FULL_PAGE_STATUS_CODE].includes(status)) {
    return <FullPageErrorMapper status={status} />;
  }

  /**
   * Layout 컴포넌트 렌더링 전에 부분 에러를 보여줘야하는 경우 Mapper 렌더링
   */
  if ([...WITH_GNB_STATUS_CODE].includes(status)) {
    return <WithGnbErrorMapper status={status} />;
  }

  /**
   * 리전 관련 에러인 경우 서비스에서 노출하고자하는 컴포넌트를 보여줘야한다.
   */
  if ([...ONLY_COMPONENT_STATUS_CODE].includes(status)) {
    return <InServiceErrorMapper status={status} />;
  }

  return <>{children}</>;
};

export default ErrorWrapper;
